import axios from "@/utils/axios";

export interface UserDataCognito {
    role: string| null,
    has_done_warmup: boolean | null,
    increaseTimesFinished: boolean
}

export interface UserDataGigya {
    id: string,
    role: string,
    has_done_warmup: boolean | null
}

export interface UserDataPermissionsResponse {
    status: string,
    message: string
}

export type UserData = UserDataCognito | UserDataGigya;

export async function getUserData() : Promise<UserData> {
    return axios.then(axios => axios.get(`${process.env.NEXT_PUBLIC_API_URL}/user/user-data`)
        .then(response => response.data));
}

export async function postUserData(body: object & {userType: string}) : Promise<UserData> {
    return axios.then(axios => axios.post(`${process.env.NEXT_PUBLIC_API_URL}/user/user-data`, body)
        .then(response => response.data));
}
  
export async function postUserPermissionsCheck() : Promise<UserDataPermissionsResponse> {
return axios.then(axios => axios.post(`${process.env.NEXT_PUBLIC_API_URL}/user/user-permissions-check`)
    .then(response => response.data));
}

export async function putUserData(body: object) : Promise<UserData> {
    return axios.then(axios => axios.put(`${process.env.NEXT_PUBLIC_API_URL}/user/user-data`, body)
        .then(response => response.data));
}